import { AssetType } from '@peritasai/types';

export const ASSET_TYPE_OPTIONS = [
  { value: AssetType.CASE_CART },
  { value: AssetType.TRAY },
  { value: AssetType.EQUIPMENT },
  { value: AssetType.STRETCHER },
  { value: AssetType.IMPLANT },
];
